import { NgModule } from '@angular/core';
import { BasePanelComponent } from '@shared/modules/base-panel/components/base-panel/base-panel.component';
import { SharedModule } from '@shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { BasePanelService } from '@shared/modules/base-panel/services/base-panel.service';
import { MobileNavigationComponent } from '@shared/modules/base-panel/components/mobile-navigation/mobile-navigation.component';
import { UIModule } from '@shared/modules/ui/ui.module';
import { SignUpHeaderComponent } from './components/sign-up-header/sign-up-header.component';
import { SignupHumburgerComponent } from './components/sign-up-header/components/signup-humburger/signup-humburger.component';
import { SignupMobileNavigationComponent } from './components/signup-mobile-navigation/signup-mobile-navigation.component';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { HeaderComponent } from './components/header/header.component';
import { TopProgressBarComponent } from '@shared/components/top-progress-bar/top-progress-bar.component';
import { HeaderActionMenuCompanyComponent } from './components/header/components/header-action-menu/components/header-action-menu-company/header-action-menu-company.component';
import { HeaderActionMenuComponent } from './components/header/components/header-action-menu/header-action-menu.component';
import { HeaderActionMenuNotificationComponent } from './components/header/components/header-action-menu/components/header-action-menu-notification/header-action-menu-notification.component';

@NgModule({
  declarations: [
    BasePanelComponent,
    HeaderActionMenuNotificationComponent,
    MobileNavigationComponent,
    SignUpHeaderComponent,
    SignupHumburgerComponent,
    SignupMobileNavigationComponent
  ],
  imports: [
    SharedModule,
    TopProgressBarComponent,
    TranslateModule,
    UIModule,
    NgClickOutsideDirective,
    HeaderComponent,
    HeaderActionMenuCompanyComponent,
    HeaderActionMenuComponent
  ],
  exports: [BasePanelComponent, HeaderActionMenuComponent],
  providers: [BasePanelService]
})
export class BasePanelModule {}
